import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import ToastContainer from './ToastContainer';
import Routes from './routes';
import Navigation from './Navigation';
import { UserAuthContext } from 'context/UserAuthContext';
import useUserAuth from './useUserAuth';
import useMaintenance from 'hooks/useMaintenance';
import { useNavigation } from './Navigation/hooks';

const LayoutContainer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userAuth = useUserAuth();
  const { maintenanceFlg, clearMaintenanceFlags } = useMaintenance();
  const { isVisible, onToggleNavigation } = useNavigation();

  // メンテナンスフラグが設定された場合にメンテナンス画面遷移を行う
  useEffect(() => {
    if (maintenanceFlg) {
      clearMaintenanceFlags();
      if (!location.pathname.match('/maintenance')) {
        navigate('/maintenance');
      }
    }
  }, [clearMaintenanceFlags, location.pathname, maintenanceFlg, navigate]);

  return (
    <>
      <UserAuthContext.Provider value={userAuth}>
        <Header />
        <ContentWrapper>
          <Navigation
            isVisible={isVisible}
            onToggleNavigation={onToggleNavigation}
          />
          <MainContentWrapper>
            <Routes />
          </MainContentWrapper>
          <ToastContainer />
        </ContentWrapper>
      </UserAuthContext.Provider>
    </>
  );
};

const ContentWrapper = styled.div`
  position: relative;
  top: 51px;
  display: flex;
  width: 100%;
  height: calc(100% - 51px);
  `;

const MainContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto;
`;

export default LayoutContainer;
